import React, { useState, useEffect, useContext, Component, useRef } from 'react';
import { useNavigate,Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import spaceAudio from '../../assets/audio/space.mp3'; // ✅ Correct way to import audio
import scrollSound from '../../assets/audio/scroll.mp3'; // ✅ Correct way to import audio

const TestingHeader = () => {
 
  const [openMenu, setOpenMenu] = useState({});


  const MENU_ITEMS =  [
  {
    "id": 1001,
    "text": "Home",
    "link": "/",
    "target": "_self",
    "children": []
  },
  {
    "id": 1002,
    "text": "About",
    "link": "#",
    "target": "_self",
    "children": [
      {
        "id": 1101,
        "text": "Profile",
        "link": "/profile",
        "target": "_self",
        "children": []
      },
      {
        "id": 1102,
        "text": "Career",
        "link": "/career",
        "target": "_self",
        "children": []
      },
      {
        "id": 1103,
        "text": "CSR",
        "link": "/csr",
        "target": "_self",
        "children": []
      }
    ]
  },
  {
    "id": 1003,
    "text": "Security",
    "link": "/security",
    "target": "_self",
    "children": [
      {
        "id": 1201,
        "text": "Perimeter Security",
        "link": "/security/perimeter-security",
        "target": "_self",
        "children": [
          {
            "id": 120101,
            "text": "AltimaFence (Electric Fence System)",
            "link": "/security/perimeter-security/altimafence-electric-fence-system",
            "target": "_self",
            "children": []
          },
          {
            "id": 120102,
            "text": "Fence Monitoring & Alerts",
            "link": "/security/perimeter-security/fence-monitoring-alerts",
            "target": "_self",
            "children": []
          },
          {
            "id": 120103,
            "text": "Fiber Fence Perimeter Security",
            "link": "/security/perimeter-security/fiber-fence",
            "target": "_self",
            "children": []
          },
          {
            "id": 120104,
            "text": "Laser Fence Perimeter Security",
            "link": "/security/perimeter-security/laser-fence",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1202,
        "text": "Video Surveillance Systems (CCTV)",
        "link": "/security/video-surveillance",
        "target": "_self",
        "children": [
          {
            "id": 120201,
            "text": "Hanwha",
            "link": "/security/video-surveillance/hanwha",
            "target": "_self",
            "children": []
          },
          {
            "id": 120202,
            "text": "Tyco American Dynamics",
            "link": "/security/video-surveillance/tyco-american-dynamics",
            "target": "_self",
            "children": []
          },
          {
            "id": 120203,
            "text": "Panasonic",
            "link": "/security/video-surveillance/panasonic",
            "target": "_self",
            "children": []
          },
          {
            "id": 120204,
            "text": "Honeywell",
            "link": "/security/video-surveillance/honeywell",
            "target": "_self",
            "children": []
          },
          {
            "id": 120205,
            "text": "ANPR Cam",
            "link": "/security/video-surveillance/anpr-cam",
            "target": "_self",
            "children": []
          },
          {
            "id": 120206,
            "text": "Remote Monitoring – Milestone & Genetec",
            "link": "/security/video-surveillance/remote-monitoring-milestone-genetec",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1203,
        "text": "Fire",
        "link": "/security/fire",
        "target": "_self",
        "children": [
          {
            "id": 120301,
            "text": "Fire Alarm System",
            "link": "/security/fire/fire-alarm-system",
            "target": "_self",
            "children": []
          },
          {
            "id": 120302,
            "text": "Honeywell Fire",
            "link": "/security/fire/honeywell-fire",
            "target": "_self",
            "children": []
          },
          {
            "id": 120303,
            "text": "Simplex by Johnson Control",
            "link": "/security/fire/simplex-johnson-control",
            "target": "_self",
            "children": []
          },
          {
            "id": 120304,
            "text": "Verbena",
            "link": "/security/fire/verbena",
            "target": "_self",
            "children": []
          },
          {
            "id": 120305,
            "text": "Bosch Fire Alarm",
            "link": "/security/fire/bosch-fire-alarm",
            "target": "_self",
            "children": []
          },
          {
            "id": 120306,
            "text": "PA (Public Address Systems)",
            "link": "/security/fire/public-address-system",
            "target": "_self",
            "children": []
          },
          {
            "id": 120307,
            "text": "Linear Heat Sensing System for Cables",
            "link": "/security/fire/linear-heat-sensing",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1204,
        "text": "Intrusion Detection & Alarm Systems",
        "link": "/security/intrusion-detection",
        "target": "_self",
        "children": [
          {
            "id": 120401,
            "text": "Motion Sensors",
            "link": "/security/intrusion-detection/motion-sensors",
            "target": "_self",
            "children": []
          },
          {
            "id": 120402,
            "text": "Door/Window Sensors",
            "link": "/security/intrusion-detection/door-window-sensors",
            "target": "_self",
            "children": []
          },
          {
            "id": 120403,
            "text": "Infrared and Laser Detectors",
            "link": "/security/intrusion-detection/infrared-laser-detectors",
            "target": "_self",
            "children": []
          },
          {
            "id": 120404,
            "text": "Panic Alarms",
            "link": "/security/intrusion-detection/panic-alarms",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1205,
        "text": "Access Control & Attendance Systems",
        "link": "/security/access-control",
        "target": "_self",
        "children": [
          {
            "id": 120501,
            "text": "Biometric Systems",
            "link": "/security/access-control/biometric-systems",
            "target": "_self",
            "children": []
          },
          {
            "id": 120502,
            "text": "Face Access",
            "link": "/security/access-control/face-access",
            "target": "_self",
            "children": []
          },
          {
            "id": 120503,
            "text": "Iris Access",
            "link": "/security/access-control/iris-access",
            "target": "_self",
            "children": []
          },
          {
            "id": 120504,
            "text": "Suprema",
            "link": "/security/access-control/suprema",
            "target": "_self",
            "children": []
          },
          {
            "id": 120505,
            "text": "Idemia Morpho",
            "link": "/security/access-control/idemia-morpho",
            "target": "_self",
            "children": []
          },
          {
            "id": 120506,
            "text": "Time Attendance & Access Control Software",
            "link": "/security/access-control/time-attendance-software",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1206,
        "text": "Entrance Automation",
        "link": "/security/entrance-automation",
        "target": "_self",
        "children": [
          {
            "id": 120601,
            "text": "Boom Barriers",
            "link": "/security/entrance-automation/boom-barriers",
            "target": "_self",
            "children": []
          },
          {
            "id": 120602,
            "text": "Bollards",
            "link": "/security/entrance-automation/bollards",
            "target": "_self",
            "children": []
          },
          {
            "id": 120603,
            "text": "Under Vehicle Scanning Systems (UVSS)",
            "link": "/security/entrance-automation/uvss",
            "target": "_self",
            "children": []
          }
        ]
      }
    ]
  },
  {
    "id": 1004,
    "text": "AV Solution",
    "link": "/av-solutions",
    "target": "_self",
    "children": [
      {
        "id": 1301,
        "text": "Home Theatre & Audio Solutions",
        "link": "/av-solutions/home-theatre-audio",
        "target": "_self",
        "children": [
          {
            "id": 130101,
            "text": "Custom Home Theatre Setup",
            "link": "/av-solutions/home-theatre-audio/custom-home-theatre",
            "target": "_self",
            "children": []
          },
          {
            "id": 130102,
            "text": "Surround Sound Systems",
            "link": "/av-solutions/home-theatre-audio/surround-sound",
            "target": "_self",
            "children": []
          },
          {
            "id": 130103,
            "text": "Multi-room Audio (Wireless & Wired)",
            "link": "/av-solutions/home-theatre-audio/multi-room-audio",
            "target": "_self",
            "children": []
          },
          {
            "id": 130104,
            "text": "Projector",
            "link": "/av-solutions/home-theatre-audio/projector",
            "target": "_self",
            "children": []
          },
          {
            "id": 130105,
            "text": "Sonance, XSCACE & Bose – Projector Content (LG, Sony, BENQ, Christie)",
            "link": "/av-solutions/home-theatre-audio/sonance-xscace-bose-projectors",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1302,
        "text": "Digital Signage & Video Walls",
        "link": "/av-solutions/digital-signage-video-walls",
        "target": "_self",
        "children": [
          {
            "id": 130201,
            "text": "Indoor & Outdoor Digital Signage",
            "link": "/av-solutions/digital-signage-video-walls/indoor-outdoor",
            "target": "_self",
            "children": []
          },
          {
            "id": 130202,
            "text": "LED Video Walls",
            "link": "/av-solutions/digital-signage-video-walls/led-video-walls",
            "target": "_self",
            "children": []
          },
          {
            "id": 130203,
            "text": "Smart Classroom Solution",
            "link": "/av-solutions/digital-signage-video-walls/smart-classroom",
            "target": "_self",
            "children": []
          },
          {
            "id": 130204,
            "text": "Aero, LG & AET",
            "link": "/av-solutions/digital-signage-video-walls/aero-lg-aet",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1303,
        "text": "Auditorium Solutions",
        "link": "/av-solutions/auditorium-solutions",
        "target": "_self",
        "children": [
          {
            "id": 130301,
            "text": "Stage Lighting Systems",
            "link": "/av-solutions/auditorium-solutions/stage-lighting",
            "target": "_self",
            "children": []
          },
          {
            "id": 130302,
            "text": "Acoustic Panels & Soundproofing",
            "link": "/av-solutions/auditorium-solutions/acoustic-panels-soundproofing",
            "target": "_self",
            "children": []
          },
          {
            "id": 130303,
            "text": "Large Projection & Display Systems",
            "link": "/av-solutions/auditorium-solutions/large-projection-display",
            "target": "_self",
            "children": []
          },
          {
            "id": 130304,
            "text": "Audio & Microphone Systems",
            "link": "/av-solutions/auditorium-solutions/audio-microphone-systems",
            "target": "_self",
            "children": []
          },
          {
            "id": 130305,
            "text": "Martin Audio, British Acoustics, Bose, Beta3, Sony & Christie Projectors",
            "link": "/av-solutions/auditorium-solutions/martin-audio-british-acoustics-bose-beta3-sony-christie",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1304,
        "text": "Commercial Cinema Solutions",
        "link": "/av-solutions/commercial-cinema",
        "target": "_self",
        "children": [
          {
            "id": 130401,
            "text": "Professional Theatre Sound Systems",
            "link": "/av-solutions/commercial-cinema/professional-sound-systems",
            "target": "_self",
            "children": []
          },
          {
            "id": 130402,
            "text": "New Film Release",
            "link": "/av-solutions/commercial-cinema/new-film-release",
            "target": "_self",
            "children": []
          },
          {
            "id": 130403,
            "text": "Fiber Fence Perimeter Security",
            "link": "/av-solutions/commercial-cinema/fiber-fence-perimeter-security",
            "target": "_self",
            "children": []
          },
          {
            "id": 130404,
            "text": "Projection & Large Format Displays",
            "link": "/av-solutions/commercial-cinema/projection-large-format-displays",
            "target": "_self",
            "children": []
          },
          {
            "id": 130405,
            "text": "Pulz, Electro Voice & British Acoustics",
            "link": "/av-solutions/commercial-cinema/pulz-electro-voice-british-acoustics",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1305,
        "text": "Boardroom / Conference Automation",
        "link": "/av-solutions/boardroom-conference-automation",
        "target": "_self",
        "children": [
          {
            "id": 130501,
            "text": "Office Automation",
            "link": "/av-solutions/boardroom-conference-automation/office-automation",
            "target": "_self",
            "children": []
          },
          {
            "id": 130502,
            "text": "Crestron",
            "link": "/av-solutions/boardroom-conference-automation/crestron",
            "target": "_self",
            "children": []
          }
        ]
      }
    ]
  },
  {
    "id": 1005,
    "text": "Home Automation",
    "link": "/home-automation",
    "target": "_self",
    "children": [
      {
        "id": 1401,
        "text": "Lighting Control",
        "link": "/home-automation/lighting-control",
        "target": "_self",
        "children": [
          {
            "id": 140101,
            "text": "Scene-based Lighting",
            "link": "/home-automation/lighting-control/scene-based-lighting",
            "target": "_self",
            "children": []
          },
          {
            "id": 140102,
            "text": "Dimming Solutions",
            "link": "/home-automation/lighting-control/dimming-solutions",
            "target": "_self",
            "children": []
          },
          {
            "id": 140103,
            "text": "Motion Sensors",
            "link": "/home-automation/lighting-control/motion-sensors",
            "target": "_self",
            "children": []
          },
          {
            "id": 140104,
            "text": "App & Voice Control",
            "link": "/home-automation/lighting-control/app-voice-control",
            "target": "_self",
            "children": []
          },
          {
            "id": 140105,
            "text": "From Crestron Website",
            "link": "/home-automation/lighting-control/crestron",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1402,
        "text": "Keypad",
        "link": "/home-automation/keypad",
        "target": "_self",
        "children": [
          {
            "id": 140201,
            "text": "Basalte",
            "link": "/home-automation/keypad/basalte",
            "target": "_self",
            "children": []
          },
          {
            "id": 140202,
            "text": "Vurve",
            "link": "/home-automation/keypad/vurve",
            "target": "_self",
            "children": []
          },
          {
            "id": 140203,
            "text": "Ekinex",
            "link": "/home-automation/keypad/ekinex",
            "target": "_self",
            "children": []
          },
          {
            "id": 140204,
            "text": "Treco",
            "link": "/home-automation/keypad/treco",
            "target": "_self",
            "children": []
          },
          {
            "id": 140205,
            "text": "Miraki",
            "link": "/home-automation/keypad/miraki",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1403,
        "text": "Scheduling & Smart Scenes",
        "link": "/home-automation/scheduling-smart-scenes",
        "target": "_self",
        "children": [
          {
            "id": 140301,
            "text": "Time-based Control",
            "link": "/home-automation/scheduling-smart-scenes/time-based-control",
            "target": "_self",
            "children": []
          },
          {
            "id": 140302,
            "text": "Event-based Automation",
            "link": "/home-automation/scheduling-smart-scenes/event-based-automation",
            "target": "_self",
            "children": []
          },
          {
            "id": 140303,
            "text": "Lifestyle Modes (Movie, Away, Morning, Party, Night)",
            "link": "/home-automation/scheduling-smart-scenes/lifestyle-modes",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1404,
        "text": "Video Intercom & Access",
        "link": "/home-automation/video-intercom-access",
        "target": "_self",
        "children": [
          {
            "id": 140401,
            "text": "Indoor Panels",
            "link": "/home-automation/video-intercom-access/indoor-panels",
            "target": "_self",
            "children": []
          },
          {
            "id": 140402,
            "text": "Video Intercom Units",
            "link": "/home-automation/video-intercom-access/video-intercom-units",
            "target": "_self",
            "children": []
          },
          {
            "id": 140403,
            "text": "Digital Door Locks",
            "link": "/home-automation/video-intercom-access/digital-door-locks",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1405,
        "text": "Integrated Security + Automation",
        "link": "/home-automation/integrated-security-automation",
        "target": "_self",
        "children": [
          {
            "id": 140501,
            "text": "CCTV + Intrusion Integration",
            "link": "/home-automation/integrated-security-automation/cctv-intrusion",
            "target": "_self",
            "children": []
          },
          {
            "id": 140502,
            "text": "Panic Buttons & Alerts",
            "link": "/home-automation/integrated-security-automation/panic-buttons-alerts",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1406,
        "text": "Curtain & Blinds Automation",
        "link": "/home-automation/curtain-blinds-automation",
        "target": "_self",
        "children": [
          {
            "id": 140601,
            "text": "Motorized Curtains & Smart Blinds",
            "link": "/home-automation/curtain-blinds-automation/motorized-curtains-smart-blinds",
            "target": "_self",
            "children": []
          },
          {
            "id": 140602,
            "text": "Sunlight & Temperature-based Control",
            "link": "/home-automation/curtain-blinds-automation/sunlight-temperature-control",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1407,
        "text": "HVAC & AC Control",
        "link": "/home-automation/hvac-ac-control",
        "target": "_self",
        "children": [
          {
            "id": 140701,
            "text": "Smart Thermostats & Scheduling",
            "link": "/home-automation/hvac-ac-control/smart-thermostats-scheduling",
            "target": "_self",
            "children": []
          },
          {
            "id": 140702,
            "text": "Remote Access",
            "link": "/home-automation/hvac-ac-control/remote-access",
            "target": "_self",
            "children": []
          }
        ]
      },
      {
        "id": 1408,
        "text": "Wireless Networking",
        "link": "/home-automation/wireless-networking",
        "target": "_self",
        "children": [
          {
            "id": 140801,
            "text": "WiFi Solutions",
            "link": "/home-automation/wireless-networking/wifi-solutions",
            "target": "_self",
            "children": []
          }
        ]
      }
    ]
  },
  {
    "id": 1006,
    "text": "Blogs",
    "link": "/blogs",
    "target": "_self",
    "children": []
  },
  
  {
    "id": 1007,
    "text": "Contact",
    "link": "/contact",
    "target": "_self",
    "children": []
  }
];

// simple helper
const isMegaMenu = (item) =>
  Array.isArray(item.children) &&
  item.children.length > 0 &&
  item.children.some((child) => Array.isArray(child.children) && child.children.length > 0);

    return (
        <>
 


         <div data-sticky-type="always">
          
  <motion.header   initial={{ opacity: 0, y: -50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay: 0 }}
     className="header-1 header-floating header-sticky">
      <div className='position-relative'>

   
    <div className="container position-relative">
      <div className="header-grid">
        <Link className="header-logo px-2 py-3" to="/" aria-label="Consulo">
          <img
           src="assets/img/altima-logo.webp"
            alt="Consulo Logo"
            width={189}
            height={32}
          />
        </Link>
        <div>
          <nav className="header-nav drawer-menu" style={{borderRight:'0px'}}>
            <div className="d-lg-none header-nav-headings">
              <a className="header-logo" href="index.html" aria-label="Consulo">
                <img
                  src="assets/img/altima-logo.webp"
                  alt="Consulo Logo"
                  width={189}
                  height={32}
                  loading="lazy"
                />
              </a>
              <div
                className="svg-wrapper menu-close"
                data-drawer=".drawer-menu"
              >
                <svg
                  width="30px"
                  height="30px"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00386 9.41816C7.61333 9.02763 7.61334 8.39447 8.00386 8.00395C8.39438 7.61342 9.02755 7.61342 9.41807 8.00395L12.0057 10.5916L14.5907 8.00657C14.9813 7.61605 15.6144 7.61605 16.0049 8.00657C16.3955 8.3971 16.3955 9.03026 16.0049 9.42079L13.4199 12.0058L16.0039 14.5897C16.3944 14.9803 16.3944 15.6134 16.0039 16.0039C15.6133 16.3945 14.9802 16.3945 14.5896 16.0039L12.0057 13.42L9.42097 16.0048C9.03045 16.3953 8.39728 16.3953 8.00676 16.0048C7.61624 15.6142 7.61624 14.9811 8.00676 14.5905L10.5915 12.0058L8.00386 9.41816Z"
                    fill="currentColor"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
            </div>
 

            <ul className="header-menu list-unstyled">
  {MENU_ITEMS.map((item) => {
    const hasChildren = item.children && item.children.length > 0;
    const mega = isMegaMenu(item);

    // 1) No children → simple link (Home, Blogs, Contact)
    if (!hasChildren) {
      return (
        <li key={item.id} className="nav-item">
          <Link
            className="menu-link menu-link-main"
            to={item.link}
            target={item.target}
          >
            {item.text}
          </Link>
        </li>
      );
    }

    // 2) Has children but NOT mega → simple dropdown (About)
    if (!mega) {
      return (
        <li   
        onMouseEnter={() => setOpenMenu(item.id)}
        onMouseLeave={() => setOpenMenu(null)} 
        key={item.id} className="nav-item">
          <a className="menu-link menu-link-main menu-accrodion" href={item.link}>
            {item.text} <i className="ri-arrow-down-s-line" />
          </a>

          <div className="header-submenu menu-absolute submenu-color">
                   {openMenu === item.id && (
            <ul className="list-unstyled">
              {item.children.map((sub,index) => (
                <motion.li 
                initial={{ opacity: 0, y: 50 }}
                              whileInView={{ opacity: 1, y: 0 }}
                              viewport={{ once: true, amount: 0.3 }}
                              transition={{
                                duration: 0.5,
                                delay: 0 + index * 0.1,
                              }}
                           className="nav-item">
                  <Link
                  
                    className="menu-link text-dark"
                    to={sub.link}
                    target={sub.target}
                  >
                    {sub.text}
                  </Link>
                </motion.li>
              ))}
            </ul>) }
          </div>
        </li>
      );
    }

    // 3) Mega menu (Security, AV Solution, Home Automation)
    return (
      <li
        key={item.id}
        className="nav-item nav-item-static"
        onMouseEnter={() => setOpenMenu(item.id)}
        onMouseLeave={() => setOpenMenu(null)}
      >
        <a
          className="menu-link menu-link-main menu-accrodion"
          href={item.link}
        >
          {item.text}
          <i className="ri-arrow-down-s-line"></i>
        </a>

        {/* only show megamenu when hovered */}
        {openMenu === item.id && (
          <div className="header-megamenu header-submenu menu-absolute submenu-color">
            <div className="d-flex">
              {/* Left card – you can customize per menu if you want */}
              <div className="header-card bg-light p-4 col-2">
                <motion.div
                 initial={{ opacity: 0, y: 50 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true, amount: 0.3 }}
                          transition={{ duration: 0.5, delay: 0 }} 
                          className="d-flex align-items-center justify-content-between">
                  <h4>{item.text}</h4>
                  <Link
                    to={item.link}
                    className="fw-light text-dark text-decoration-none"
                  >
                    <i className="ri-arrow-right-long-line text-20"></i>
                  </Link>
                </motion.div>
                <motion.img
                  src="https://www.homeautomat.in/images/home-automat-solution.webp"
                  className="p-2 bg-white border mt-4"
                  alt={item.text}
                  initial={{ opacity: 0, y: 50 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true, amount: 0.3 }}
                          transition={{ duration: 0.5, delay: 0.1 }} 
                />
                <motion.p 
                initial={{ opacity: 0, y: 50 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true, amount: 0.3 }}
                          transition={{ duration: 0.5, delay: 0.2 }} 
                   className="mt-2">
                  Upgrade your home with our smart solutions, offering enhanced
                  convenience, security, and entertainment for a modern living
                  experience.
                </motion.p>

<motion.div  initial={{ opacity: 0, y: 50 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true, amount: 0.3 }}
                          transition={{ duration: 0.5, delay: 0.3 }}  >
                             <Link className="mt-3 subheading text-decoration-none text-15 text-dark subheading-bg bg-white">
                  Know More <i className="ri-arrow-right-up-line"></i>
                </Link> 
</motion.div>
               
              </div>

              {/* Right – dynamic columns from JSON */}
              <div className="col-10">
                <div className="p-3">
                  <div className="row">
                    {item.children.map((column) => (
                      <div key={column.id} className="col-md-3 mb-4">
                        <motion.h6
                          initial={{ opacity: 0, y: 50 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true, amount: 0.3 }}
                          transition={{ duration: 0.5, delay: 0  }}
                          className="border-bottom mb-2 pb-2 text-Gradient"
                        >
                          {column.text}
                        </motion.h6>

                        <ul className="list-group list-group-flush">
                          {column.children?.map((linkItem, index) => (
                            <motion.li
                              key={linkItem.id}
                              className="list-group-item border-0 pb-0"
                              initial={{ opacity: 0, y: 50 }}
                              whileInView={{ opacity: 1, y: 0 }}
                              viewport={{ once: true, amount: 0.3 }}
                              transition={{
                                duration: 0.5,
                                delay: 0 + index * 0.1,
                              }}
                            >
                              <Link
                                to={linkItem.link}
                                target={linkItem.target}
                                className="text-decoration-none text-dark"
                              >
                                {linkItem.text}
                              </Link>
                            </motion.li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </li>
    );
  })}
</ul>


          </nav>
        </div>
        <div className="header-actions d-flex align-items-center d-none">
          <div
            className="header-search search-open svg-wrapper"
            data-drawer=".modal-search"
          >
            <svg
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="black"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.7104 20.2875L18.0004 16.6075C19.4405 14.8119 20.1379 12.5328 19.9492 10.2388C19.7605 7.94476 18.7001 5.81025 16.9859 4.27411C15.2718 2.73797 13.0342 1.91697 10.7333 1.97993C8.43243 2.04289 6.24311 2.98502 4.61553 4.6126C2.98795 6.24018 2.04582 8.4295 1.98286 10.7304C1.9199 13.0313 2.7409 15.2688 4.27704 16.983C5.81318 18.6971 7.94769 19.7576 10.2417 19.9463C12.5357 20.135 14.8148 19.4376 16.6104 17.9975L20.2904 21.6775C20.3834 21.7712 20.494 21.8456 20.6158 21.8964C20.7377 21.9471 20.8684 21.9733 21.0004 21.9733C21.1324 21.9733 21.2631 21.9471 21.385 21.8964C21.5068 21.8456 21.6174 21.7712 21.7104 21.6775C21.8906 21.491 21.9914 21.2418 21.9914 20.9825C21.9914 20.7231 21.8906 20.4739 21.7104 20.2875ZM11.0004 17.9975C9.61592 17.9975 8.26255 17.5869 7.1114 16.8178C5.96026 16.0486 5.06305 14.9553 4.53324 13.6762C4.00342 12.3972 3.8648 10.9897 4.1349 9.63183C4.40499 8.27396 5.07168 7.02668 6.05065 6.04772C7.02961 5.06875 8.27689 4.40206 9.63476 4.13197C10.9926 3.86187 12.4001 4.00049 13.6792 4.53031C14.9583 5.06012 16.0515 5.95733 16.8207 7.10847C17.5899 8.25962 18.0004 9.61299 18.0004 10.9975C18.0004 12.854 17.2629 14.6345 15.9501 15.9472C14.6374 17.26 12.8569 17.9975 11.0004 17.9975Z"
                fill="black"
                fillOpacity={1}
              />
            </svg>
          </div>
          <div className="theme-modal modal-search ">
            <div className="modal-container">
              <div className="modal-header">
                <div
                  className="svg-wrapper search-close"
                  data-drawer=".modal-search"
                >
                  <svg
                    width="30px"
                    height="30px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.00386 9.41816C7.61333 9.02763 7.61334 8.39447 8.00386 8.00395C8.39438 7.61342 9.02755 7.61342 9.41807 8.00395L12.0057 10.5916L14.5907 8.00657C14.9813 7.61605 15.6144 7.61605 16.0049 8.00657C16.3955 8.3971 16.3955 9.03026 16.0049 9.42079L13.4199 12.0058L16.0039 14.5897C16.3944 14.9803 16.3944 15.6134 16.0039 16.0039C15.6133 16.3945 14.9802 16.3945 14.5896 16.0039L12.0057 13.42L9.42097 16.0048C9.03045 16.3953 8.39728 16.3953 8.00676 16.0048C7.61624 15.6142 7.61624 14.9811 8.00676 14.5905L10.5915 12.0058L8.00386 9.41816Z"
                      fill="currentColor"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </div>
              <div className="modal-main d-flex align-items-center justify-content-center">
                <form
                  action="#"
                  className="form-search d-flex align-items-center justify-content-center flex-wrap"
                >
                  <label htmlFor="Search" className="text text-30">
                    {" "}
                    Search{" "}
                  </label>
                  <input
                    type="text"
                    placeholder="What are you looking for?"
                    name="search"
                    id="Search"
                    className="text text-16"
                    autoComplete="off"
                  />
                  <button
                    className="button button--primary"
                    type="submit"
                    aria-label="Search"
                  >
                    <span className="svg-wrapper">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.7104 20.2875L18.0004 16.6075C19.4405 14.8119 20.1379 12.5328 19.9492 10.2388C19.7605 7.94476 18.7001 5.81025 16.9859 4.27411C15.2718 2.73797 13.0342 1.91697 10.7333 1.97993C8.43243 2.04289 6.24311 2.98502 4.61553 4.6126C2.98795 6.24018 2.04582 8.4295 1.98286 10.7304C1.9199 13.0313 2.7409 15.2688 4.27704 16.983C5.81318 18.6971 7.94769 19.7576 10.2417 19.9463C12.5357 20.135 14.8148 19.4376 16.6104 17.9975L20.2904 21.6775C20.3834 21.7712 20.494 21.8456 20.6158 21.8964C20.7377 21.9471 20.8684 21.9733 21.0004 21.9733C21.1324 21.9733 21.2631 21.9471 21.385 21.8964C21.5068 21.8456 21.6174 21.7712 21.7104 21.6775C21.8906 21.491 21.9914 21.2418 21.9914 20.9825C21.9914 20.7231 21.8906 20.4739 21.7104 20.2875ZM11.0004 17.9975C9.61592 17.9975 8.26255 17.5869 7.1114 16.8178C5.96026 16.0486 5.06305 14.9553 4.53324 13.6762C4.00342 12.3972 3.8648 10.9897 4.1349 9.63183C4.40499 8.27396 5.07168 7.02668 6.05065 6.04772C7.02961 5.06875 8.27689 4.40206 9.63476 4.13197C10.9926 3.86187 12.4001 4.00049 13.6792 4.53031C14.9583 5.06012 16.0515 5.95733 16.8207 7.10847C17.5899 8.25962 18.0004 9.61299 18.0004 10.9975C18.0004 12.854 17.2629 14.6345 15.9501 15.9472C14.6374 17.26 12.8569 17.9975 11.0004 17.9975Z"
                          fill="currentColor"
                          fillOpacity={1}
                        />
                      </svg>
                    </span>
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div className="header-separator">
            <svg
              width={11}
              height={53}
              viewBox="0 0 11 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="10.5"
                x2="10.5"
                y2={53}
                stroke="black"
                strokeOpacity="0.7"
              />
              <line
                x1="0.5"
                y1={12}
                x2="0.5"
                y2={42}
                stroke="black"
                strokeOpacity="0.3"
              />
            </svg>
          </div>
          <a
            href="contact.html"
            aria-label="contact us"
            className="button button--secondary button--slim d-none d-lg-inline-flex"
          >
            Let's Talk
            <span className="svg-wrapper">
              <svg
                className="icon-20"
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.3365 7.84518L6.16435 15.0173L4.98584 13.8388L12.158 6.66667H5.83652V5H15.0032V14.1667H13.3365V7.84518Z"
                  fill="currentColor"
                />
              </svg>
            </span>
          </a>
          <div
            className="svg-wrapper menu-open d-lg-none"
            data-drawer=".drawer-menu"
          >
            <svg
              width={52}
              height={52}
              viewBox="0 0 52 52"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx={26}
                cy={26}
                r="25.5"
                fill="black"
                stroke="currentColor"
              />
              <path
                d="M32.5 18.2857C32.5 17.5757 31.9179 17 31.2 17H14.3C13.5821 17 13 17.5757 13 18.2857C13 18.9958 13.5821 19.5714 14.3 19.5714H31.2C31.9179 19.5714 32.5 18.9957 32.5 18.2857ZM14.3 24.7143H37.7C38.4179 24.7143 39 25.29 39 26C39 26.7101 38.4179 27.2857 37.7 27.2857H14.3C13.5821 27.2857 13 26.7101 13 26C13 25.29 13.5821 24.7143 14.3 24.7143ZM14.3 32.4286H26C26.7179 32.4286 27.3 33.0042 27.3 33.7143C27.3 34.4243 26.7179 35 26 35H14.3C13.5821 35 13 34.4243 13 33.7143C13 33.0042 13.5821 32.4286 14.3 32.4286Z"
                fill="currentColor"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
       </div>
  </motion.header>
</div>


        </>

    );
};

export default TestingHeader